import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PublicNav from '../components/PublicNav';
import Seo from '../components/Seo';
import CorpFooter from '../components/CorpFooter';
import PublisherGuide from '../components/PublisherGuide';

const PUB_REF_KEY = 'vokelle_pubref';

const STEPS = ['step1', 'step2', 'step3'];

export default function PublishersLanding() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  // Bir yayıncının referans linkiyle gelindiyse (?pref=), server sahibinin
  // kayıt formuna kadar hatırlanır — bkz. Register.jsx.
  useEffect(() => {
    const pref = searchParams.get('pref');
    if (pref) localStorage.setItem(PUB_REF_KEY, pref);
  }, [searchParams]);

  return (
    <>
      <Seo
        title="Yayıncılar"
        description="YouTube, TikTok, Twitch ve Kick yayıncıları için ücretsiz takip linki. Sunucu sahibinden onay gerektirmez; videolarının kaç tıklama getirdiğini canlı gör."
      />
      <PublicNav />
      <main className="page-enter">
        <section className="container" style={{ padding: 'var(--sp-7) 0 var(--sp-6)', maxWidth: 780 }}>
          <span className="eyebrow">{t('publishersLanding.eyebrow')}</span>
          <h1 style={{ fontSize: 'clamp(1.8rem, 4vw, 2.6rem)', marginTop: 10 }}>{t('publishersLanding.title')}</h1>
          <p style={{ color: 'var(--text-2)', fontSize: 16, marginTop: 12, lineHeight: 1.6 }}>{t('publishersLanding.sub')}</p>

          <div style={{ display: 'flex', gap: 12, marginTop: 'var(--sp-5)', flexWrap: 'wrap', alignItems: 'center' }}>
            <Link to="/yayinci/kayit" className="btn">{t('publishersLanding.cta_publisher')}</Link>
            <Link to="/yayinci/giris" className="btn btn-ghost">{t('publishersLanding.cta_login')}</Link>
          </div>
        </section>

        <section id="nasil" className="container" style={{ padding: 'var(--sp-6) 0', maxWidth: 780 }}>
          <h2 style={{ fontSize: '1.3rem', marginBottom: 'var(--sp-4)' }}>{t('publishersLanding.how_title')}</h2>
          <div style={{ display: 'grid', gap: 'var(--sp-3)' }}>
            {STEPS.map((s, i) => (
              <div key={s} className="card" style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                <div style={{
                  width: 30, height: 30, borderRadius: '50%', background: 'var(--accent)', color: '#000',
                  display: 'grid', placeItems: 'center', fontWeight: 700, fontSize: 13.5, flexShrink: 0,
                }}>{i + 1}</div>
                <div>
                  <div style={{ fontWeight: 600, marginBottom: 4 }}>{t(`publishersLanding.${s}_title`)}</div>
                  <div style={{ color: 'var(--text-3)', fontSize: 13.5, lineHeight: 1.5 }}>{t(`publishersLanding.${s}_desc`)}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 'var(--sp-4)' }}>
            <PublisherGuide collapsible={false} />
          </div>
        </section>

        <section className="container" style={{ padding: 'var(--sp-6) 0 var(--sp-7)', maxWidth: 780 }}>
          <div className="card" style={{ textAlign: 'center', padding: 'var(--sp-5)' }}>
            <h3 style={{ fontSize: '1.15rem', marginBottom: 8 }}>{t('publishersLanding.owner_title')}</h3>
            <p style={{ color: 'var(--text-3)', fontSize: 13.5, marginBottom: 16 }}>{t('publishersLanding.owner_desc')}</p>
            <Link to="/register" className="btn btn-ghost btn-sm">{t('publishersLanding.owner_cta')}</Link>
          </div>
        </section>
      </main>
      <CorpFooter />
    </>
  );
}
